var React = require('react');

function LocationIcon (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("circle",{"fill":"none","stroke":"#000000","strokeWidth":"2","strokeMiterlimit":"10","cx":"32","cy":"22","r":"6","key":0}),React.createElement("path",{"fill":"none","stroke":"#000000","strokeWidth":"2","strokeMiterlimit":"10","d":"M53,22.735C52.948,10.73,43.599,1,32,1\r\n\t\ts-21,9.73-21,21.735C11,38.271,31.965,63,31.965,63S53.069,38.271,53,22.735z","key":1})]));
}

LocationIcon.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"64px","height":"64px","viewBox":"0 0 64 64","enableBackground":"new 0 0 64 64","xmlSpace":"preserve"};

module.exports = LocationIcon;

LocationIcon.default = LocationIcon;
